



















































import SelectBase from './select-base'

import store from '@/store'
import AddressModal from '@/components/modal_source/address'

# queryKeyword = (keyword) ->
#   if keyword? and keyword.length > 0 
#     "keyword: \"Address1,FirstName,LastName,Id>>>#{keyword}\"" 
#   else 
#     ""
# query = (keyword) -> (
#   "{
#     companies(
#       page: 1
#       limit: 10
#       sort: \"DateAdded:DESC\"
#       #{queryKeyword keyword}
#     ) {
#       recordset { Id Address1 Fullname Email City State Zipcode } 
#     }
#   }"
# )

export default {
  name: 'SourceSelectCompanies'
  mixins: [SelectBase]
  props: {    
  }
  methods: {
    _fetch: (value) -> (
      # self = this
      # { companies } = await store.dispatch 'centric2', { query: (query value) }
      # if companies?
      #   companies.recordset = companies.recordset.map (node) -> self.modifyOpt node
      #   companies
      # else
      #   { recordset: [] }
      await { recordset: [] }
    )

    # allow add new bank
    createAddress: -> (
      self = this
      done = (ones) -> self.selectByValue ones[0].Id
      this.openModal AddressModal, 450, { done }
    )

    # edit bank account
    editAddress: (opt) -> (
      self = this
      { Id } = opt
      done = (ones) -> self.selectByValue ones[0].Id
      this.openModal AddressModal, 450, { done }, { Id }
    )

    modifyOpt: (option) -> (
      option.Label = option.Address1
      option
    )
  }
}
